import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaUtensils, FaHeart } from 'react-icons/fa';
import { selectAllUrlParams, updateSingleParam } from '../../store/slices/urlParamsSlice';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const dispatch = useDispatch();
  const event = useSelector(selectAllUrlParams);
  const currentTheme = event?.theme || 'event';
  const isRestaurantTheme = currentTheme === 'restaurant';

  const toggleTheme = () => {
    const newTheme = currentTheme === 'event' ? 'restaurant' : 'event';
    dispatch(updateSingleParam({ key: 'theme', value: newTheme }));
  };

  return (
    <button
      className={`theme-toggle ${isRestaurantTheme ? 'restaurant' : 'event'}`}
      onClick={toggleTheme}
      aria-label={`Switch to ${isRestaurantTheme ? 'event' : 'restaurant'} theme`}
      title={`Current: ${currentTheme === 'event' ? 'Event' : 'Restaurant'} theme. Click to switch.`}
    >
      <div className="theme-toggle-content">
        {isRestaurantTheme ? (
          <>
            <FaUtensils className="theme-icon" />
            <span className="theme-label">Restaurant</span>
          </>
        ) : (
          <>
            <FaHeart className="theme-icon" />
            <span className="theme-label">Event</span>
          </>
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;
